import { createContext } from 'react';

export type ErrorContextValue = {
    setError: () => void;
};

const errorContext = createContext<ErrorContextValue>({ setError: (): void => {} });

export default errorContext;
